import type React from 'react'

/**
 * Chevron right (8 × 14) — used by StatusBanner affordance.
 *
 * Path data is byte-identical to
 * `metro/docs/superpowers/specs/assets/stationcard-v2/icon-chevron-right.svg`
 * (Figma export). Stroke is bound to `currentColor` so consumers can
 * tint via CSS `color: ...` (banner foreground token).
 */
export function IconChevronRight(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M1 1L7 7L1 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
